export default __webpack_public_path__ + "static/media/locationMarker.adced503.svg";